import React, { lazy, Suspense, useEffect } from 'react';
import { LazyMotion, domAnimation } from 'framer-motion';
import { TopBar } from './components/sections/TopBar';
import { Hero } from './components/sections/Hero';
import { ProblemAgitation } from './components/sections/ProblemAgitation';
import { StickyCTA } from './components/ui/StickyCTA';
import { initMetaPixel } from './utils/metaPixel';

// Everything below the hero is code-split into its own chunk and loaded right
// after the initial paint — none of it is needed to render the first screen,
// so it shouldn't compete with the hero/LCP for the browser's main thread.
const TrustStats = lazy(() => import('./components/sections/TrustStats').then(mod => ({
  default: mod.TrustStats
})));
const Transformation = lazy(() => import('./components/sections/Transformation').then(mod => ({
  default: mod.Transformation
})));
const Method = lazy(() => import('./components/sections/Method').then(mod => ({
  default: mod.Method
})));
const ForYou = lazy(() => import('./components/sections/ForYou').then(mod => ({
  default: mod.ForYou
})));
const WhatYouGet = lazy(() => import('./components/sections/WhatYouGet').then(mod => ({
  default: mod.WhatYouGet
})));
const BonusesDetail = lazy(() => import('./components/sections/BonusesDetail').then(mod => ({
  default: mod.BonusesDetail
})));
const InsideKit = lazy(() => import('./components/sections/InsideKit').then(mod => ({
  default: mod.InsideKit
})));
const InstantAccess = lazy(() => import('./components/sections/InstantAccess').then(mod => ({
  default: mod.InstantAccess
})));
const Testimonials = lazy(() => import('./components/sections/Testimonials').then(mod => ({
  default: mod.Testimonials
})));
const FAQ = lazy(() => import('./components/sections/FAQ').then(mod => ({
  default: mod.FAQ
})));
const FinalCTA = lazy(() => import('./components/sections/FinalCTA').then(mod => ({
  default: mod.FinalCTA
})));
const Pricing = lazy(() => import('./components/sections/Pricing').then(mod => ({
  default: mod.Pricing
})));
const Guarantee = lazy(() => import('./components/sections/Guarantee').then(mod => ({
  default: mod.Guarantee
})));
const Footer = lazy(() => import('./components/sections/Footer').then(mod => ({
  default: mod.Footer
})));
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <LazyMotion features={domAnimation} data-id="element-0" data-mp="86w3alkjrvxo">
      <div className="w-full min-h-full bg-bg-primary font-body text-ink" data-id="element-1" data-mp="3gle8mfj3sxdl">
        <TopBar data-id="element-2" data-mp="3glo2wfb6lqp3" />
        <main data-id="element-3" data-mp="3gj1vqgs7dd7e">
          <Hero data-id="element-4" data-mp="3bmjsjlcitmx6" />
          <ProblemAgitation data-id="element-5" data-mp="3bn2zk70muqwf" />
          <Suspense fallback={null} data-id="element-6" data-mp="3bnuwpm9vowot">
            <TrustStats data-id="element-7" data-mp="3qb7klhn5reid" />
            <Transformation data-id="element-8" data-mp="3qbfx38fdcht1" />
            <Method data-id="element-9" data-mp="3qcr0v88tdpk5" />
            <ForYou data-id="element-10" data-mp="3qdakcte44m0a" />
            <WhatYouGet data-id="element-11" data-mp="3lkhbbtbm2rie" />
            <BonusesDetail data-id="element-12" data-mp="3lk7ky4mnmic6" />
            <InsideKit data-id="element-13" data-mp="3liwlgh08rwqv" />
            <InstantAccess data-id="element-14" data-mp="3limrkic2t5fw" />
            <Testimonials data-id="element-15" data-mp="2xudatutpz7vm" />
            <FAQ data-id="element-16" data-mp="2xtlqxh9hiyl6" />
            <FinalCTA data-id="element-17" data-mp="2xt27tx83m45k" />
            <Pricing data-id="element-18" data-mp="2xsk4kgn0qpo5" />
            <Guarantee data-id="element-19" data-mp="2sw243syq1dhm" />
          </Suspense>
        </main>
        <Suspense fallback={null} data-id="element-20" data-mp="2svjyw6u2zoxk">
          <Footer data-id="element-21" data-mp="18e19rkmjbok1" />
        </Suspense>
        <StickyCTA data-id="element-22" data-mp="18cznek02jfn0" />
      </div>
    </LazyMotion>;
}